import { render, staticRenderFns } from "./CreateAttribute.vue?vue&type=template&id=9641f9a8"
import script from "./CreateAttribute.vue?vue&type=script&lang=js"
export * from "./CreateAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports